export default __webpack_public_path__ + "static/media/logo-white.c7f483dd.svg";